import { createSlice } from '@reduxjs/toolkit';
import { CartProduct } from '../../types/shop.type';

const SELECTED_ADDRESS_INDEX = 'SELECTED_ADDRESS_INDEX';
const SELECTED_PAYMENT_METHOD_ID = 'SELECTED_PAYMENT_METHOD_ID';

interface Cart {
  items: CartProduct[];
  appliedCounpon?: any;
  selectedAddressIndex?: number;
  selectedOfferId?: any;
  selectedPaymentMethodId?: string;
}

const initialState: Cart = {
  items: [],
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    refreshCart(state) {
      state.items = [];
    },
    updateCartStore(state, action) {
      if (action.payload) {
        state.items = [...action.payload];
      }
    },
    addNewItem(state, action) {
      if (action.payload) {
        state.items = [...state.items, { ...action.payload, quantity: 1 }];
      }
    },
    removeItem(state, action) {
      if (action.payload && action.payload.Id) {
        state.items = state.items.filter((s) => s.Id !== action.payload.Id);
      }
    },
    updateQuantity(state, action) {
      if (action.payload && action.payload.Id && action.payload.quantity) {
        state.items = state.items.map((s) => {
          if (s.Id === action.payload.Id) {
            return {
              ...s,
              quantity: action.payload.quantity,
            };
          }
          return s;
        });
      }
    },
    getLocalSelectedAddress(state) {
      const seletedIndex = window.localStorage.getItem(SELECTED_ADDRESS_INDEX);
      if (seletedIndex !== null) {
        state.selectedAddressIndex = parseInt(seletedIndex, 10);
      }
    },
    setSelectedAddressIndex(state, action) {
      if (action.payload && action.payload.selectedIndex) {
        state.selectedAddressIndex = action.payload.selectedIndex;
        window.localStorage.setItem(
          SELECTED_ADDRESS_INDEX,
          action.payload.selectedIndex.toString(),
        );
      }
    },
    setSelectedPaymentMethodId(state, action) {
      if (action.payload && action.payload.selectedPaymentMethodId) {
        state.selectedPaymentMethodId = action.payload.selectedPaymentMethodId;
        window.localStorage.setItem(
          SELECTED_PAYMENT_METHOD_ID,
          action.payload.selectedPaymentMethodId,
        );
      }
    },
    setSelectedOfferId(state, action) {
      if (action.payload && action.payload.selectedIndex) {
        state.selectedOfferId = action.payload.selectedIndex;
      }
    },
    clearSelectedAddressIndex(state) {
      state.selectedAddressIndex = undefined;
      window.localStorage.removeItem(SELECTED_ADDRESS_INDEX);
    },
  },
});

export const {
  refreshCart,
  addNewItem,
  removeItem,
  updateQuantity,
  updateCartStore,
  setSelectedAddressIndex,
  clearSelectedAddressIndex,
  getLocalSelectedAddress,
  setSelectedOfferId,
  setSelectedPaymentMethodId,
} = cartSlice.actions;

export default cartSlice.reducer;
